import { DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioGroup, MatRadioModule } from '@angular/material/radio';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslocoModule } from '@ngneat/transloco';
import { firstValueFrom } from 'rxjs';
import { EndpointsService } from '../../modules/admin/endpoints/endpoints.service';
import { ContractWorkSummaryRow } from '../../modules/admin/endpoints/endpoints.types';
import { Net2BeepleLocator } from '../../core/dtype/dtype.types';

@Component({
  selector: 'app-change-workplace-guide-dialog',
  imports: [MatIconModule, MatButtonModule, TranslocoModule, MatRadioGroup, MatRadioModule],
  templateUrl: './change-workplace-guide-dialog.component.html',
  styleUrls: ['./change-workplace-guide-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangeWorkplaceGuideDialogComponent {

    private readonly dialogRef = inject(MatDialogRef<ChangeWorkplaceGuideDialogComponent>);
    private readonly endpointsService = inject(EndpointsService);
    private readonly snackBar = inject(MatSnackBar)
    public data: { row: ContractWorkSummaryRow, locator: Net2BeepleLocator, period, year } = inject(MAT_DIALOG_DATA);

    public workplaceData = this.data.row.workplaceData;
    public workplaceNameSelected = signal<string>(this.data.row.workplaceData[0]?.workplaceCode ?? '');

    public selectedWorkplaceData = computed(() => {
        const wd = this.data.row.workplaceData.find(wd => wd.workplaceCode === this.workplaceNameSelected());
        return { ...wd, forced: true }
    });

    async approve() {
        const request = {
            contractMonthlyOid: this.data.row.oid,
            workplaceData: this.selectedWorkplaceData(),
            locator: this.data.locator
        };

        if (request) {
            const reply = await firstValueFrom(this.endpointsService.changeWorkplaceGuide(request));
            this.snackBar.open('Guía de lugar de trabajo actualizada correctamente', undefined, { duration: 3000 });
            this.dialogRef.close(reply.row);
        }
    }


    closeDialog() {
        this.dialogRef.close();
    }
}
